<template>
  <div :class="classtrs1"> 
  <slot></slot>
  </div>
</template>
<script>
import { mapState} from "vuex";
import {
  resourcepath,
  iskong,
} from "../commonjs/commonfn.js";
export default {
  name: "divanim",
  props: ["delay", "durtime",  "isActiveT", "effect"],
  data() {
    return {
      resourcepath: resourcepath,
    };
  },

  mounted() {},
  methods: {},

  computed: {
    delay1() {
            if (!iskong(this.effect)) {
      let attr = this.delay.toString().split(".");
      return attr[0] + "D" + attr[1];
            }else{
              return 0;
            }
    },
    durtime1() {
          if (!iskong(this.effect)) {
      let attr = this.durtime.toString().split(".");

      return attr[0] + "D" + attr[1];
         }else{
           return 0;
         }
    },
    classtrs1() {
      var classtrs;
      if (!iskong(this.effect)) {
        var animjson={};
        animjson['animated']=this.isActiveT;
        animjson[this.effect]=this.isActiveT;
        animjson['vhidden']=!this.isActiveT;
        classtrs=['  animdur'+this.durtime1+' animdelay'+this.delay1+'',animjson];
      } else {
        classtrs= " "+this.effect;
      }
      return classtrs;
    },
    ...mapState(["isalljiazai", "isActive"]),
  },
};
// 
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/divanim.vue